export function createServiceResult({
  data,
  source = "api",
  error = null,
  usedFallback = false,
}) {
  return {
    data,
    source,
    error,
    usedFallback,
  };
}
